import React, { forwardRef } from "react";
export const QuiMenuItemBox = forwardRef((props, ref) => {
    return React.createElement("div", Object.assign({ ref: ref }, props, { "aria-disabled": true, style: { outline: "none" }, tabIndex: -1 }));
});
QuiMenuItemBox.displayName = "QuiMenuItemBox";
